import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
import translationEN from './locales/en/translation.json'
import translationPTBR from './locales/pt-br/translation.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt-BR',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { translation: translationEN },
      'pt-BR': { translation: translationPTBR },
    },
  })

export default i18n
